import Drawer from '@mui/material/Drawer';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { styled } from '@mui/material/styles';

export const StyledDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'start',
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
  
}));

export const StyledDrawer = styled(Drawer)<{ drawerwidth: number }>(({ drawerwidth }) => ({
  width: drawerwidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerwidth,
    boxSizing: 'border-box',
  },
}));

export const StyledSwipeableDrawer = styled(SwipeableDrawer)<{ drawerwidth: number }>(({ drawerwidth }) => ({
  width: drawerwidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: drawerwidth,
    boxSizing: 'border-box',
  },
}));

export const styledButtonMenu = { borderRadius: '50% 0 0 50%', px: 1, minWidth: 'auto' };
export const styledNavigation = { height: 40, width: 40, mx: 'auto' };
export const styledNavigationItemIcon = { minWidth: 'initial' };

export const getSelectedStyle = (buttonBackgroundColor: { selected: string; hover: string }) => ({
  justifyContent: 'center',
  py: 2,
  '&.Mui-selected': {
    backgroundColor: buttonBackgroundColor.selected,
    '&:hover': {
      backgroundColor: buttonBackgroundColor.hover,
    },
  },
});
